import { axios } from './axios';

export const getFreeProducts = async (country: string) => {
  return axios.get(`/products/free?country=${country}`);
};
